import backBtn from "../assets/icons/back-btn.png";
import logo from "../assets/doctio-logo.svg";
import fraseIkon from "../assets/icons/Paper-icon + circle.svg";
import sygeplejerske from "../assets/people/TBV03928.png";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [statsData, setStatsData] = useState({
    doctor: 0,
    medstudent: 0,
    nurse: 0,
    other: 0,
  });

  useEffect(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValidEmail(emailRegex.test(email));
  }, [email]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch(
          "https://test.doctio.dk/api/statistics/professions"
        );
        const jsonData = await response.json();
        setStatsData(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, []);

  const handleResetPassword = async () => {
    try {
      const response = await fetch(
        "https://test.doctio.dk/api/sendresetemail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
          }),
        }
      );

      if (response.ok) {
        toast.success("Password reset email er blevet sendt!");
      } else {
        toast.error("Hov der skete en fejl ved afsendelse af mailen");
      }
    } catch (error) {
      console.error("Error sending reset email:", error);
      toast.error("Hov der skete en fejl ved afsendelse af mailen");
    }
  };

  return (
    <div>
      <section className="md:h-screen">
        <div className="grid mx-auto h-full md:grid-cols-2">
          <div className="bg-white w-full container md:w-2/3 mx-auto md:py-6 order-2 md:order-1">
            <div className="header mt-2 hidden md:block flex items-center justify-between md:block">
              <button
                className="flex items-center md:mb-24"
                onClick={() => navigate(-1)}
              >
                <img src={backBtn} width={26} className="mr-3" alt="Tilbage" />
                <p className="text-doctio-green">Tilbage</p>
              </button>
              <img
                src={logo}
                width={150}
                className="md:mr-3 md:mb-20"
                alt="Logo"
              />
            </div>

            <h1 className="text-d2xl mt-10 md:mt-0 font-bold leading-tight tracking-tight text-doctio-green md:text-d2xl">
              Glemt password?
            </h1>

            <p>
              Ingen problem. Indtast email og vi sender dig et link til at
              nulstille dit password.
            </p>

            <form
              className="space-y-4 mt-8 signup-form md:space-y-8"
              action="#"
            >
              <div>
                <input
                  type="email"
                  name="email"
                  id="emaillogin"
                  pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="border border-[#E8E2DE] text-gray-900 sm:text-dsm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-6"
                  placeholder="Email"
                  required={true}
                />
              </div>
            </form>

            <button
              type="button"
              onClick={handleResetPassword}
              disabled={!isValidEmail}
              style={{ opacity: isValidEmail ? 1 : 0.6 }}
              className="text-white transition-colors mt-10 mb-10 w-full duration-300 ease-in-out font-bold rounded-full bg-doctio-green hover:bg-white hover:text-doctio-green hover:shadow-md focus:ring-4 focus:outline-none px-4 py-4 text-center mr-3 md:mr-0"
            >
              Nulstil password
            </button>
            <p className="italic">
              Problemer med at logge ind?
              <Link to="/kontakt" className="text-doctio-green underline ml-2">
                Kontakt os her.
              </Link>
            </p>
          </div>

          <div className="relative w-full mx-auto container md:max-w-none md:bg-doctio-lightgreen md:py-40 md:h-screen order-1 md:order-2 overflow-hidden">
            <div className="shadow-right"></div>
            <div className="md:w-2/3 mx-auto">
              <div className="image-container relative">
                <div className="header mt-4 mb-4 md:hidden flex items-center justify-between md:block">
                  <Link to="/">
                    <img
                      src={logo}
                      width={150}
                      className="md:mr-3 md:mb-20 w-[120px] md:w-[150px]"
                      alt="Logo"
                    />
                  </Link>
                  <button
                    className="flex items-center md:mb-8"
                    onClick={() => navigate(-1)}
                  >
                    <img
                      src={backBtn}
                      width={26}
                      className="mr-3"
                      alt="Tilbage"
                    />
                    <p className="text-doctio-green">Tilbage</p>
                  </button>
                </div>
                <img
                  src={sygeplejerske}
                  className="mr-3 h-96 object-cover md:h-auto w-full md:object-fit picture-shadow rounded-3xl"
                  alt="Sygeplejerske"
                />

                <div className="mt-12 mb-10 hidden md:block">
                  <p className="leading-tight tracking-tight">
                    <span className="font-bold">Navn Navnesen</span>, Titel lige
                    her, Hospitalsnavn.
                  </p>
                  <p className="mt-2 italic">Bruger af Doctio</p>
                </div>

                <div className="absolute frase-ikon-sign hidden md:block left-[-95px] top-[40%]">
                  <img
                    src={fraseIkon}
                    width={199}
                    className="mr-3"
                    alt="Fraseikon"
                  />
                </div>
              </div>
              <ToastContainer />

              <div className="mx-auto hidden md:block">
                <dl className="grid grid-cols-2 py-12 border-t doctio-grey-border gap-x-2 text-left lg:grid-cols-3">
                  <div className="mx-auto mb-8 md:mb-0 flex w-full flex-col px-4">
                    <dt className="text-left text-dbase text-doctio-green font-medium">
                      Læger
                    </dt>
                    <h3 className="order-first text-left text-d3xl md:text-d5xl font-light tracking-tight mb-4 text-doctio-green">
                      {statsData.doctor}
                    </h3>
                  </div>
                  <div className="mx-auto mb-8 md:mb-0 flex w-full flex-col px-4">
                    <dt className="text-left text-dbase text-doctio-green font-medium">
                      Lægestuderende
                    </dt>
                    <h3 className="order-first text-left text-d3xl md:text-d5xl font-light tracking-tight mb-4 text-doctio-green">
                      {statsData.medstudent}
                    </h3>
                  </div>
                  <div className="mx-auto mb-8 md:mb-0 flex w-full flex-col px-4">
                    <dt className="text-left text-dbase text-doctio-green font-medium">
                      Sygeplejesker
                    </dt>
                    <h3 className="order-first text-left text-d3xl md:text-d5xl font-light tracking-tight mb-4 text-doctio-green">
                      {statsData.nurse}
                    </h3>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
